import Headroom from "react-headroom";

// import custom components
import MenuDesktop from "@/layout/Menu/MenuDesktop";
import MenuMobile from "@/layout/Menu/MenuMobile";

// import hooks
import { useWindowSize } from "@/hooks/useWindowSize";

type Props = {
  menuColor: string;
};

function Menu({ menuColor }: Props) {
  const { width } = useWindowSize();

  return (
    <Headroom disableInlineStyles>
      {width < 768 ? (
        <MenuMobile color={menuColor} />
      ) : (
        <MenuDesktop color={menuColor} />
      )}
    </Headroom>
  );
}

export default Menu;
